import { CategoryPills } from "~/features/products/categories/category-pills.component";
import { useFiltersContext } from "../filters.context";

export function ProductCategoriesPills() {
	const { filters, config, onFilterChange, facets } = useFiltersContext();
	return (
		// data-vaul-no-drag: the mobile filter drawer (vaul) captures pointer
		// gestures for drag-to-dismiss, which blocks horizontal scrolling of
		// the pills; this attribute opts the pills row out of drag detection.
		<div data-testid="product-categories-pills" data-vaul-no-drag>
			{/* -mx-6 escapes the drawer's px-6 so scrolling pills bleed to the
			    screen edge; px-4 restores the 16px default inset per design review. */}
			<CategoryPills
				categories={config.categories}
				value={filters.category}
				onChange={(value) => onFilterChange("category", value)}
				className="-mx-6 px-4 scroll-px-4"
				categoryFacets={facets?.category}
			/>
		</div>
	);
}
